/**
 * CompareBar Component
 * Floating bar for comparing selected strategies
 */
import { useNavigate } from 'react-router-dom'

interface CompareBarProps {
  selectedIds: string[]
  onClear: () => void
}

export default function CompareBar({ selectedIds, onClear }: CompareBarProps) {
  const navigate = useNavigate()

  if (selectedIds.length === 0) return null

  const handleCompare = () => {
    const ids = selectedIds.join(',')
    navigate(`/compare?ids=${ids}`)
  }

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-gray-800 border border-gray-700 rounded-xl shadow-2xl px-6 py-4 flex items-center gap-6">
        <div className="flex items-center gap-3">
          <span className="text-2xl">⚖️</span>
          <div>
            <div className="text-white font-semibold">
              {selectedIds.length} {selectedIds.length === 1 ? 'strategy' : 'strategies'} selected
            </div>
            <div className="text-gray-400 text-sm">
              {selectedIds.length < 2 ? 'Select at least 2 to compare' : 'Ready to compare!'}
            </div>
          </div>
        </div>
        
        <div className="flex items-center gap-3">
          <button
            onClick={onClear}
            className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors"
          >
            Clear
          </button>
          <button
            onClick={handleCompare}
            disabled={selectedIds.length < 2}
            className={`px-6 py-2 rounded-lg font-semibold transition-colors ${
              selectedIds.length >= 2
                ? 'bg-primary hover:bg-primary-dark text-white'
                : 'bg-gray-600 text-gray-400 cursor-not-allowed'
            }`}
          >
            Compare Now
          </button>
        </div>
      </div>
    </div>
  )
}
